import React, { useEffect, useState } from "react";
import Header from "../../../components/Header/Header";
import "./Dashboard.css"
import "./../Dashboard.css"

import NotificationBar from "../../../components/NotificationBar/NotificationBar";
import MyProperties from "../../../components/MyProperties/MyProperties";

import MidCard from "../../../components/Mid.Card/Mid.Card";
import SideNavBar from "../../../components/SideNavBar/SideNavBar";
import SVGProgress from "../../../components/svg_progress/SVGProgress";
import { Link, useNavigate } from "react-router-dom";
import { pmTransactionInsite } from "../../../services/payment.method.service";
import MiniGraph from "../../../components/MiniGraph/MiniGraph";
import ToggleButton from "../../../components/ToggleButton/ToggleButton";
import NoDataFound from "../../../components/NoDataFoundWidget/NoDataFound";

export default function PropertyManagerDashboard({ userData = null, title = "Welcome back, Anthony" }) {
  const [pageLabel, setPageLabel] = useState("");
  const [currentMonthRent, setCurrentMonthRent] = useState(0);
  const [currentMonthRentPercentage, setCurrentMonthRentPercentage] = useState(0);
  const [rentCollected, setRentCollected] = useState(null);
  const [currentMonthOntime, setCurrentMonthOntime] = useState(0);
  const [onTimeRentCollected, setOnTimeRentCollected] = useState(null);
  const [currentMonthLabel, setCurrentMonthLabel] = useState('');
  const [selectedType, setSelectedType] = useState("percent")

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Manager | Dashboard | Ando";
    setPageLabel("Welcome back, " + userData.data.first_name);

    pmTransactionInsite(userData.data.id, 4)
      .then((resp) => {
        if (resp?.status) {
          let expected = resp?.data?.perMonthExpectedRent ?? 0
          let currentMonth = parseInt(resp?.data?.rentForPastMonths[resp?.data?.rentForPastMonths?.length - 1]?.amount_paid ?? 0)
          let dataNewRentValue = currentMonth;
          let dataNewRent = Math.round((currentMonth / parseInt(resp?.data?.rentForPastMonths[resp?.data?.rentForPastMonths?.length - 1]?.expectedRent ?? expected)) * 100)
          let currentMonthDate = new Date(`${resp?.data?.rentForPastMonths[resp?.data?.rentForPastMonths?.length - 1]?.month_start} 00:00:00`)
          setCurrentMonthLabel(currentMonthDate.toLocaleString('default', { month: 'short' }).substring(0, 3) + "'" + currentMonthDate.getFullYear().toString().substring(2, 4))
          let t = dataNewRent ? dataNewRent !== "NaN" ? dataNewRent : 0 : 0 ?? 0
          setCurrentMonthRent(resp?.data?.rentForPastMonths[resp?.data?.rentForPastMonths?.length - 1]?.amount_paid)
          setCurrentMonthRentPercentage(t > 100 ? 100 : t)
          setRentCollected(resp?.data?.rentForPastMonths?.filter(((item, index) => index < 3))?.map((item) => {
            let date = new Date(`${item?.month_start} 00:00:00`)
            let mn = date.toLocaleString('default', { month: 'long' }).substring(0, 3);
            let yr = date.getFullYear().toString().substring(2, 4);
            let per = Math.round((parseInt(item?.amount_paid ?? 0) / parseInt(item?.expectedRent ?? expected)) * 100);

            return {
              month: mn ? mn == "NaN" ? 0 : mn : 0,
              year: yr ? yr == "NaN" ? 0 : yr : 0,
              percent: per ? per == "NaN" ? 0 : per > 100 ? 100 : per : 0,
              data: item?.amount_paid ?? 0,
            }

          }))

          let expectedOntime = resp?.data?.ontimePayments?.totalMonthlyExpectedTransaction;          
          let currentMonthOnTime = parseInt(resp?.data?.ontimePayments?.data[resp?.data?.ontimePayments?.data?.length - 1]?.on_time_payments ?? 0)
          let dataNew = parseInt(expectedOntime) == 0 && (currentMonthOnTime != 0) ? 100 : Math.round((currentMonthOnTime / parseInt(expectedOntime)) * 100)
          let temp = dataNew ? dataNew !== "NaN" ? dataNew : 0 : 0 ?? 0 
          setCurrentMonthOntime(temp > 100 ? 100 : temp)
          let tempp = resp?.data?.ontimePayments?.data?.filter(((item, index) => index < 3))?.map((item) => {
            let date = new Date(`${item?.transaction_date} 00:00:00`)
            let t = Math.round((parseInt(item?.on_time_payments ?? 0) / parseInt(item?.total_transaction ?? 1)) * 100);
            return {
              month: date.toLocaleString('default', { month: 'long' }).substring(0, 3),
              year: date.getFullYear().toString().substring(2, 4),
              percent: t ? t == "NaN" ? 0 : t > 100 ? 100 : t : 0,
            }
          })
          setOnTimeRentCollected(tempp)
        }
      })
  }, []);
  
  return (
    <main style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Header showNotification={true} name={userData?.data?.first_name + " " + userData?.data?.last_name} />
      <section className="mainPanel" style={{ flex: 1, gap: '30px', paddingTop: 0, display: "flex", width: '100%', maxWidth: 2500 }} >

        <SideNavBar userData={userData} />

        <div className="DashContainer">
          <div className='dashHeader'>
            <div className="pageTitle">{pageLabel}</div>
          </div>
          <div className="rowFormInput rowCustom">
            <div className="columnFormInput" style={{ gap: '20px', paddingTop: 15, flex: 1 }}>
              <MyProperties userData={userData} activeUser="propertyManager" />
              {/* Collected Rent Details */}
              <MidCard>
                {
                  currentMonthRent == 0 && rentCollected?.find((item) => item.percent > 0) == undefined ?
                    <div style={{ flex: 1, padding: '10px' }}>
                      <div className="typeTitle">Rent Collected</div>
                      <NoDataFound message="Data will appear once rent has been collected." />
                    </div>
                    :
                    <>
                      <div className="prop-typebox" style={{ position: "relative" }}>
                        <label style={{ display: "flex", flexDirection: "row", gap: 5, position: "absolute", right: 10, top: -5, fontSize: 10 }}>$Dollars <ToggleButton name={"percent"} selected={selectedType == "percent"} toggleFunction={() => {
                          if (selectedType == "percent")
                            setSelectedType("dollar")
                          else
                            setSelectedType("percent")
                        }}
                        /> %Percent</label>
                        <div>
                          <div className="typeTitle">Rent Collected</div>
                          <div className="typeDescriptionCustom">
                            <span>Rent collected to date for the current month.</span>
                          </div>
                        </div>
                        <div>
                          {" "}
                          <SVGProgress _percentage={currentMonthRentPercentage} amount={currentMonthRent} showPercentage={selectedType == 'percent'} subTitle={currentMonthLabel} />
                        </div>
                        <div>
                          <div className="typeDescriptionCustom">
                            <span>Rent collected over the last 3 months.</span>
                          </div>
                        </div>
                        <MiniGraph json={rentCollected} selectedType={selectedType} />
                      </div>
                      <div className="view">
                        <Link onClick={() => { navigate("/property_manager/payment") }}>View Details</Link>
                      </div>
                    </>
                }
              </MidCard>
              {/* On Time Payment Details */}
              <MidCard>
                {
                  currentMonthOntime == 0 && onTimeRentCollected?.find((item) => item.percent > 0) == undefined && currentMonthRent == 0 && rentCollected?.find((item) => item.percent > 0) == undefined?
                    <div style={{ flex: 1, padding: '10px' }}>
                      <div className="typeTitle">On-Time Payments</div>
                      <NoDataFound message="Data will appear once rent has been collected." />
                    </div>
                    :
                    <div className="prop-typebox">
                      <div>
                        <div className="typeTitle">On-Time Payments</div>
                        <div className="typeDescriptionCustom">
                          <span>Rent collected on time for the current month.</span>
                        </div>
                      </div>
                      <div>
                        {" "}
                        <SVGProgress _percentage={currentMonthOntime} subTitle={currentMonthLabel} />
                      </div>
                      <div>
                        <div className="typeDescriptionCustom">
                          <span>Rent collected on time over the last 3 months.</span>
                        </div>
                      </div>
                      <MiniGraph json={onTimeRentCollected} />
                    </div>
                }
              </MidCard>
            </div>
            <div style={{ gap: '20px', paddingTop: 15 }}>
              <NotificationBar userData={userData} />
            </div>
          </div>
        </div>


      </section>
    </main>
  );
}
